import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { faqItems } from '@/mocks/faq';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '永葆青春',
  url: 'https://lztprh.cn/',
  description: '科学抗衰知识平台，汇集护肤养生、饮食运动、心理健康全方位抗衰老方案，助你由内而外绽放年轻光彩。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://lztprh.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '永葆青春 - 科学抗衰让你越活越年轻',
  description: '永葆青春汇集科学抗衰、护肤养生、生活习惯全方案，帮助你从内到外逆龄而生，掌握真正让肌肤与活力长久留存的核心方法，告别衰老困扰，重拾年轻状态。',
  url: 'https://lztprh.cn/',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}